import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useVendorAuth } from "./VendorAuthContext";
import { Loader } from "../../Components/Loader";
import VendorLogin from "./Login";
import VendorLayout from "./Layout";
import VendorDashboard from "./Dashboard";
import VendorPlaceholder from "./Placeholder";
import VendorEvents from "./Events";
import VendorRevenue from "./Revenue";
import VendorAssignments from "./Assignments";

/* ═══════════════════════════════════════════════════════════════════════════
   VENDOR PORTAL ROUTES
   Self-contained route tree: /vendor/*
   ═══════════════════════════════════════════════════════════════════════════ */

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useVendorAuth();

  if (isLoading) return <Loader />;
  if (!isAuthenticated) return <Navigate to="/vendor/login" replace />;

  return <>{children}</>;
};

const VendorRoutes: React.FC = () => {
  const { isAuthenticated, isLoading } = useVendorAuth();

  return (
    <Routes>
      {/* Login — redirect to dashboard if already authenticated */}
      <Route
        path="login"
        element={
          isLoading ? (
            <Loader />
          ) : isAuthenticated ? (
            <Navigate to="/vendor/dashboard" replace />
          ) : (
            <VendorLogin />
          )
        }
      />

      {/* Protected routes with layout shell */}
      <Route
        element={
          <ProtectedRoute>
            <VendorLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<VendorDashboard />} />
        <Route path="events" element={<VendorEvents />} />
        <Route path="assignments" element={<VendorAssignments />} />
        <Route path="pricing" element={<VendorPlaceholder title="Pricing" />} />
        <Route path="services" element={<VendorPlaceholder title="Services" />} />
        <Route path="availability" element={<VendorPlaceholder title="Availability" />} />
        <Route path="revenue" element={<VendorRevenue />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/vendor/dashboard" replace />} />
    </Routes>
  );
};

export default VendorRoutes;
